import { z } from "zod";

export const MaterielItemSchema = z.object({
  equipement: z.string(),
  modele: z.string(),
  type: z.string(),
});

export const UserSettingsBaseSchema = z.object({
  user_id: z.number().int().positive("L'ID utilisateur doit être un nombre positif"),
  list_materiel: z.array(MaterielItemSchema).optional(),
  list_intervenant: z.string().optional(),
});

export const UserSettingsSchema = UserSettingsBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date(),
  updated_at: z.date(),
});

export const UserSettingsCreateSchema = UserSettingsBaseSchema.omit({
  user_id: true,
});

export const UserSettingsUpdateSchema = z.object({
  list_materiel: z.array(MaterielItemSchema).optional(),
  list_intervenant: z.string().optional(),
});

export const UserSettingsResponseSchema = z.object({
  data: UserSettingsSchema,
  message: z.string().optional(),
});

export const UserSettingsListResponseSchema = z.object({
  data: z.array(UserSettingsSchema),
  meta: z.object({
    totalPages: z.number(),
    page: z.number(),
    limit: z.number(),
    hasNextPage: z.boolean(),
    hasPreviousPage: z.boolean(),
    total: z.number(),
  }),
});

// Types
export type MaterielItem = z.infer<typeof MaterielItemSchema>;
export type UserSettings = z.infer<typeof UserSettingsSchema>;
export type UserSettingsCreateInput = z.infer<typeof UserSettingsCreateSchema>;
export type UserSettingsUpdateInput = z.infer<typeof UserSettingsUpdateSchema>;
export type UserSettingsResponse = z.infer<typeof UserSettingsResponseSchema>;
export type UserSettingsListResponse = z.infer<typeof UserSettingsListResponseSchema>;

// Validation functions
export const validateUserSettingsCreate = (data: unknown) => {
  return UserSettingsCreateSchema.safeParse(data);
};

export const validateUserSettingsUpdate = (data: unknown) => {
  return UserSettingsUpdateSchema.safeParse(data);
};
